/**
 * @module store/tokens/actions
 *
 * @version 1.0.6
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import {
  apiGetSettings,
  apiSetFoundationsCategories,
  apiSetPointsCategories,
  apiSetStartsCategories,
  apiSetStartsPrice,
} from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const getAppSettings = async ({ commit, rootGetters }) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const settings = await apiGetSettings(userSession.accessToken.jwtToken);

      commit(types.SET_SETTINGS, settings);
    } else {
      throw new Error('Неавторизованный пользователь не может получить настрйки.');
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Action: Set number of required confirmations
 *
 * @since Version 1.0.5
 */
const setFoundationsCategories = async ({ dispatch, rootGetters }, foundationsCategories) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetFoundationsCategories(userSession.accessToken.jwtToken, foundationsCategories);
      await dispatch('getAppSettings');
    } else {
      throw new Error('Неавторизованный пользователь не может задавать настройки.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


/**
 * Action: Задает список категорий стартов
 *
 * @since Version 1.0.5
 */
const setStartsCategories = async ({ dispatch, rootGetters }, startsCategories) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetStartsCategories(userSession.accessToken.jwtToken, startsCategories);
      await dispatch('getAppSettings');
    } else {
      throw new Error('Неавторизованный пользователь не может задавать настройки.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


/**
 * Action: Задает стоимость челенджа со старатами
 *
 * @since Version 1.0.6
 */
const setStartsPrice = async ({ dispatch, rootGetters }, price) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetStartsPrice(userSession.accessToken.jwtToken, price);
      await dispatch('getAppSettings');
    } else {
      throw new Error('Неавторизованный пользователь не может задавать стоимость старта.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


/**
 * Action: Задает список категорий акций
 *
 * @since Version 1.0.5
 */
const setPointsCategories = async ({ dispatch, rootGetters }, pointsCategories) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetPointsCategories(userSession.accessToken.jwtToken, pointsCategories);
      await dispatch('getAppSettings');
    } else {
      throw new Error('Неавторизованный пользователь не может задавать настройки.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


export default {
  getAppSettings,
  setFoundationsCategories,
  setPointsCategories,
  setStartsCategories,
  setStartsPrice,
};
